<template>
  <div v-if="taskData">
      <div
        class="other-task"
        :style="{
          backgroundImage: 'url(' + taskData.material.backgroundImage + ')',
        }"
      >
      
        <div class="coupon-header">
          <div class="coupon-title">{{ taskData.material && taskData.material.title }}</div>
        </div>
        <div class="count-time">
           <CountDown
          :taskTimer="taskData.expireTime.day" 
          :ExpireShowType="taskData.expireTime.showType"
          :RemainingSeconds="taskData.expireTime.second"
          :isShowTimer="taskData.expireTime.isShow"
          @get-task-init="_initData"
        ></CountDown>
        </div>
        <div class="coupon-desc">{{ taskData.material && taskData.material.subTitle }}</div>
        <div class="coupon-invite">
          <rich-button @click="handleClick(taskData.material.redirectUrlH5)">
            {{ taskData.material && taskData.material.buttonText }}
          </rich-button>
        </div>
      </div>
  </div>
</template>
<script>
import {homepageTaskActivityCk} from '../trackEvent'
import CountDown from './countDown.vue'
import {
  getScheme
} from '@/common/js/utils'
export default {
  name: 'OtherTask',
  components: {
    CountDown
  },
  props: {
    taskData: {
      default: {}
    }
  },
  methods: {
    _initData () {
      this.$emit('_initData')
    },
    handleClick (redirectUrlH5) {
      homepageTaskActivityCk()
      if (!redirectUrlH5) return
      location.href = `${getScheme()}://${redirectUrlH5}`
    }
  }
}
</script>
<style lang="stylus" scoped>
.other-task
  background-color: #fff 
  width 702px
  height 300px
  background-size 100%
  background-position-y: bottom
  background-repeat: no-repeat
  margin 0 auto
  padding 32px 32px 0
  box-sizing border-box
  margin-bottom 20px
  border-radius: 12px
  position relative
  .coupon-header
    display flex
    justify-content space-between
    margin-bottom 14px
  .coupon-title
    width 336px
    font-family 'Aspira Medium'
    font-size 36px
    color #000000
    line-height 42px
    font-weight 500
    overflow:hidden; 
    text-overflow:ellipsis;
    display:-webkit-box; 
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2; 
  .coupon-desc
    width 332px
    font-family 'Aspira Light'
    font-size 28px
    color #000000
    line-height 34px
    font-weight 200
    margin-bottom 24px
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 2
    overflow hidden
    word-break break-all
    /*! autoprefixer: off */
    -webkit-box-orient vertical
  .coupon-invite
    height 64px
    position: absolute
    bottom: 28px
    left 32px
    .rich-btn
      height 64px
      font-family 'Aspira Medium'
      font-size 28px
      font-weight: 500
      border-radius: 8px
      display inline-block
      width auto
      padding 18px 24px
      box-sizing border-box
      max-width 300px
      overflow:hidden
      text-overflow ellipsis
      white-space nowrap
</style>
<style lang="scss" scoped>
.count-time{
  position: absolute;
  left: auto;
  right: 32px;
  top: 32px;
  width:300px;
  ::v-deep .task-timer {
    line-height: normal  !important;
    span{
      font-size: 28px !important; 
    }
  } 
  ::v-deep .task-timer-desc {
    line-height: normal  !important;
    font-size: 28px !important; 
  }
}
</style>